import { useQuery } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "./queryKeys";

export const useVerifyToken = (token: string) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: onboardingQKeys.tokenVerification(token),
    queryFn: () => api.get(`onboarding/verify/${token}`),
    select: (res: any) => res.data,
    enabled: !!token,
    retry: false, // Don't retry if token is invalid
    onError: (res: any) => {
      console.error("[From Verify Token]", res);
      handleErrors(res, "query");
    },
  });
};
